"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapLink = void 0;
var MapLink_1 = require("./MapLink");
Object.defineProperty(exports, "MapLink", { enumerable: true, get: function () { return __importDefault(MapLink_1).default; } });
//# sourceMappingURL=index.js.map